import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import { Box, Typography, Stack, Breadcrumbs } from '@mui/material';
import { useDarkMode } from '../darkMode/hook/useDarkMode';
import { useFAQ } from './hooks/useFAQ';
import {withNavigation} from "../navigation/navigation";
import {withFaqContext} from "./state/faqContext";

const FAQDetail = () => {
  const { id } = useParams();
  const { getFaqById } = useFAQ();
  const { mode } = useDarkMode();
  const navigate = useNavigate();
  const [faq, setFaq] = useState(null);
  const [loading, setLoading] = useState(true);

  const getFaqDetail = async (id) => {
    const faq = await getFaqById(id);
    setLoading(false);
    setFaq(faq);
  }

    useEffect(() => {
        getFaqDetail(id);
    }, []);
  const breadcrumbs = [
    <Typography
        className={'breadcrumbs'}
        variant={'body2'}
        onClick={() => navigate('/')}
        style={{color: mode.settings.breadcrumbColor1}}>
        Accueil
    </Typography>,
    <Typography className={'breadcrumbs'} variant={'body2'} onClick={() => navigate('/faq')}
                style={{color: mode.settings.breadcrumbColor1}}>
        Foire aux questions
    </Typography>,
    <Typography variant={'body2'} style={{color: mode.settings.textColor3}}>
        Détail
    </Typography>
  ];

  if (loading) {
    return <Typography>Chargement...</Typography>;
  }

  if (!faq && !loading) {
    return <Typography>FAQ non trouvée</Typography>;
  }

  return (
      <Stack style={{marginTop : '15px', height : '100%'}} width={'100%'}>
            <Breadcrumbs
                separator="›"
                aria-label="navigation"
                style={{color: mode.settings.textColor3, marginBottom: '15px'}}>
                {breadcrumbs}
            </Breadcrumbs>
          <Box style={{
              alignSelf: 'flex-start',
              width: '100%',
              flexGrow: 1,
              backgroundColor: mode.settings.cardBackgroundColor,
              padding: 15,
              display: 'flex',
              flexDirection: 'column',
          }}>
              <Typography variant="h3" sx={{ color: mode.settings.textColor3, alignSelf: 'center', marginBottom : 3 }}>
                  {faq.question}
              </Typography>
              <Typography variant="body1" sx={{ color: mode.settings.textColor3, alignSelf: 'center' }}>
                  {faq.response}
              </Typography>
          </Box>
      </Stack>

  );
};

export default withFaqContext(withNavigation(FAQDetail));